import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

export const AnimationContext = createContext();

export const useAnimationContext = () => useContext(AnimationContext);

export const AnimationProvider = ({children}) => {
    const collapsed = useState(false);
    const sidebarOffset = collapsed[0] ? '70px' : '350px'; // 70px is the width of the sidebar collapsed, 350px is the width of the sidebar expanded,

    return (
        <AnimationContext.Provider value={{collapsed, sidebarOffset}}>
            {children}
        </AnimationContext.Provider>
    );
};

AnimationProvider.propTypes = {
    children: PropTypes.node,
};
